import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { useHistory } from 'react-router-dom';
import { store } from './reducer';

const useStyles = makeStyles((theme) => ({
  buttons: {
    display: 'flex',
    flexFlow: 'row nowrap',
    '&>button:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
  },
}));

const OrderActionButtons = () => {
  const classes = useStyles();
  const history = useHistory();
  const {
    state: { order },
  } = useContext(store);

  const handleClickReOrder = () => {
    history.push(`/protected/admin/orders/add`, { order });
  };

  return (
    <div className={classes.buttons}>
      <Button
        variant="contained"
        size="large"
        color="secondary"
        onClick={handleClickReOrder}
        endIcon={<FileCopyIcon />}
      >
        کپی همین سفارش
      </Button>
    </div>
  );
};

export default React.memo(OrderActionButtons);
